import { FC, lazy, Suspense, useRef } from 'react'
import {
  FinanceBreakDownViews,
  FinanceCalculatorThemeProvider,
  GeneralError,
  IWidgetConfiguration,
  MinimalLoader,
  PreviewModeBanner,
  ThemedErrorMessage,
  usePlatformConfig,
  useWidgetContext,
} from '@dxp-module/common'
import BreakdownDisplay from './financeCalculatorForm/react/widgetScreen/components/BreakdownDisplay'
import GlobalCalculatorWrapper from './common/components/presentation/loaders/GlobalCalculatorWrapper'

const FullViewModeDisplay = lazy(
  () =>
    import('./financeCalculatorForm/fullViewModeDisplay/FullViewModeDisplay')
)

const FinanceCalculatorWidgetContent: FC = () => {
  const widgetRef = useRef()
  const { configuration } = useWidgetContext()
  const {
    platformConfig: {
      themeOverride,
      financeCalculator: { disableCssBaseline },
    },
  } = usePlatformConfig()
  const isBreakdownView =
    configuration.viewMode === FinanceBreakDownViews.BREAKDOWN

  const renderError = (calculatorError: GeneralError) => {
    return (
      <ThemedErrorMessage
        center={false}
        error={calculatorError}
        message="trans__fincalc__error_messages__general_error"
      />
    )
  }

  const renderContent = (configuration: IWidgetConfiguration) => {
    return (
      <>
        {isBreakdownView && configuration.breakdown ? (
          <BreakdownDisplay breakdown={configuration.breakdown} />
        ) : (
          <FullViewModeDisplay />
        )}
      </>
    )
  }

  return (
    <FinanceCalculatorThemeProvider
      themeOverride={themeOverride}
      disableCssBaseline={disableCssBaseline}
    >
      <Suspense fallback={<MinimalLoader />}>
        {!isBreakdownView && (
          <PreviewModeBanner translationId="trans__fincalc__modal__preview_header" />
        )}
        <GlobalCalculatorWrapper {...{ widgetRef, configuration }}>
          {({ calculatorError }) => {
            return (
              <>
                {calculatorError
                  ? renderError(calculatorError)
                  : renderContent(configuration)}
              </>
            )
          }}
        </GlobalCalculatorWrapper>
      </Suspense>
    </FinanceCalculatorThemeProvider>
  )
}

export default FinanceCalculatorWidgetContent
